import {
  collection,
  doc,
  limit,
  onSnapshot,
  orderBy,
  query
} from "firebase/firestore";
import moment from 'moment';
import {
  useEffect,
  useMemo,
  useRef,
  useState
} from 'react';
import { BiChevronDown, BiTransfer } from 'react-icons/bi';
import { BsHeadset } from 'react-icons/bs';
import { FaCheck } from "react-icons/fa6";
import { IoAlertOutline } from 'react-icons/io5';
import { MdNotificationsActive } from 'react-icons/md';
import { toast } from 'react-toastify';
import {
  Avatar,
  LastMessage,
  Menu,
  Modal,
  NoteClient,
  ProfileClient,
  TransferClient,
  VideoCallStatus,
  ViewerCustomerServiceOpen
} from '../../../../../../../../components';
import { useChat } from '../../../../../../../../contexts/chat';
import { useOutsideAlerter } from '../../../../../../../../hooks';
import { db } from '../../../../../../../../service/serviceChat/chatService';
import {
  addCostumerServiceInWaitingRoom,
} from '../../../../../../../../service/serviceChat/waitingRoom';
import { maskDate, NotificationChat, verificationUserExternal } from '../../../../../../../../utils';
import {
  AvatarWrapper,
  Container,
  Content,
  Date,
  IconDown,
  IconNotification,
  IsSelected,
  Line,
  Loading,
  Name,
  Room,
  Tag,
  Wrapper
} from './styled';

export function Card(props) {

  const refMenu = useRef();
  const {
    data,
    active,
    loadChats,
    onSelectedCustomer,
    selectedCustomer,
    allowAddInRoom
  } = props;

  const {
    handOpenPreview,
    onTransferCustomerByMy,
    idChat
  } = useChat();

  const isInRoom = useMemo(() => {
    return data?.sala?.usuario ? true : false
  }, [data]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [transferOpen, setTransferOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [noteOpen, setNoteOpen] = useState(false);
  const [lastMessage, setLastMessage] = useState(null);
  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(false);
  const [customerServiceOpenData, setCustomerServiceOpenData] = useState(null);
  const [isSelected, setIsSelected] = useState(false);

  useOutsideAlerter(refMenu, handleCloseMenu);

  useEffect(() => {
    if (!data.client_phone) return
    var startNotification = false;
    const q = query(
      collection(doc(db(), "chats_new", data.client_phone), "messages"),
      orderBy("date", "desc"),
      limit(1)
    );
    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        if (snapshot.size <= 0) return;
        setNotification({
          docs: snapshot.docs,
          startNotification
        });
        startNotification = true;
      },
      (error) => {
        return unsubscribe();
      }
    );
    return () => {
      unsubscribe();
    }
  }, [data.id]);
  useEffect(() => {
    if (!notification) return;
    const message = notification.docs[0].data();
    setLastMessage(message);
    if (
      (notification.startNotification) &&
      (verificationUserExternal(message)) &&
      (data.client_phone !== idChat)
    ) {
      const notification = new NotificationChat(
        message?.author,
        message?.type === 'text' ? message?.body : 'Nova mensagem',
        data.client_phone
      );
      notification.show();
    }
  }, [notification]);

  useEffect(() => {
    if (selectedCustomer?.customerServicersID?.includes(data.id)) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedCustomer, data.id]);


  const titleTransfer = () => {
    return (
      <div style={{ maxWidth: "25rem" }}>
        Transferir
        <span style={{ fontWeight: "bolder", padding: '0 0.5rem 0 0.5rem' }}>
          {data.client_name}
        </span>
        para :
      </div>
    );
  };
  function handleOpenMenu(e) {
    setAnchorEl(e?.currentTarget)
  };
  function handleCloseMenu() {
    setAnchorEl(null);
  };
  function handleOpenNote() {
    setNoteOpen(true);
  };
  function handleCloseNote() {
    setNoteOpen(false);
  };
  function handleOpenTransfer() {
    handleCloseMenu();
    setTransferOpen(true);
  };
  function handleCloseTransfer() {
    setTransferOpen(false);
  };
  function handleOpenProfile() {
    handleCloseMenu();
    setProfileOpen(true);
  };
  function handleCloseProfile() {
    setProfileOpen(false);
  };

  async function handleAddInWaitingRoom() {
    setLoading(true);
    setAnchorEl(null);
    const response = await addCostumerServiceInWaitingRoom(data.id);
    toast[response.status](response.message, { position: "top-center", theme: "colored" });
    setLoading(false);
  };

  //components
  const msgCustomerServiceOpen = (data) => {
    return (
      <div>
        <p>
          {`Já existe atendimento em aberto ! `}
        </p>
        <u
          onClick={
            () => setCustomerServiceOpenData(data)
          }
        >
          {`ver atendimento`}
        </u>
      </div>
    )
  };
  const isNote = (note) => {
    if (note === undefined || !note || note === null || note === " " || note === "undefined" || note === "null") {
      return false
    } else {
      return true
    }
  };

  async function handTransferCustomerByMy() {
    setLoading(true);
    const response = await onTransferCustomerByMy(data, false, false);
    if (response === 'error') {
      setLoading(false)
      toast.error('Lamentamos, mas não foi possível iniciar o atendimento.', { position: "top-center", theme: "colored" });
      return
    }
    if (response?.status === 'clone') {
      toast.warn(
        msgCustomerServiceOpen(response?.customerServiceOpen),
        { position: "top-center", theme: "colored" }
      );
      return setLoading(false)
    }
    setLoading(false);
  };
  function handOpenChat(e) {
    if (!selectedCustomer?.isOpen) {
      if (e.shiftKey) {
        return handTransferCustomerByMy();
      }
      handOpenPreview(data, data.client_name, 6);
    }
  };

  const handSelectedCustomer = () => {
    if (selectedCustomer?.isOpen) {
      onSelectedCustomer(data.id);
    }
  };

  return (
    <>
      <Container
        active={active}
        disabled={loading}
        isSelected={isSelected}
        onClick={() => handSelectedCustomer()}
        enabledSelection={selectedCustomer?.isOpen}
      >
        <Wrapper>
          <AvatarWrapper>
            {isSelected
              ? <IsSelected>
                <FaCheck fontSize={'2rem'} />
              </IsSelected>
              : <Avatar name={data.client_name} />
            }
          </AvatarWrapper>
          <Content>
            <Line onClick={(e) => handOpenChat(e)} className={isInRoom && 'h33'}>
              <Name>
                <span>{data.client_name}</span>
              </Name>
              <Date>
                <span>{maskDate(data.started_at) + ' - ' + moment(data.started_at).format('HH:mm')}</span>
              </Date>
            </Line>
            <Line className={isInRoom && 'h33'}>
              {data.type !== 'VIDEOCHAMADA'
                ? (<>
                  <div className='lastMessage' onClick={(e) => handOpenChat(e)}>
                    {lastMessage ? <LastMessage message={lastMessage} /> : <>...</>}
                  </div>
                  <div className='icon-line'>
                    {isNote(data.note) &&
                      <Tag type='note'>
                        <IoAlertOutline className='iconNoteInline' onClick={() => handleOpenNote()} />
                      </Tag>
                    }
                    {verificationUserExternal(lastMessage) &&
                      <IconNotification onClick={(e) => handOpenChat(e)}>
                        <MdNotificationsActive />
                      </IconNotification>
                    }
                    <IconDown>
                      <BiChevronDown onClick={(e) => handleOpenMenu(e)} />
                    </IconDown>
                    <IconDown>
                      <BiTransfer onClick={() => handleOpenTransfer()} style={{ fontSize: '1.3rem' }} />
                    </IconDown>
                  </div>
                </>)

                : (<>
                  <div className='note' onClick={(e) => handOpenChat(e)}>
                    <VideoCallStatus dataCall={data?.link} />
                  </div>
                  <div className='icon-line'>
                    {verificationUserExternal(lastMessage) &&
                      <IconNotification onClick={(e) => handOpenChat(e)}>
                        <MdNotificationsActive />
                      </IconNotification>
                    }
                    <IconDown >
                      <BiChevronDown onClick={() => handleOpenMenu()} />
                    </IconDown>
                    <IconDown>
                      <BiTransfer onClick={() => handleOpenTransfer()} style={{ fontSize: '1.3rem' }} />
                    </IconDown>
                  </div>
                </>)
              }
            </Line>
            {isInRoom &&
              <Room.Wrapper>
                <Room.Card>
                  <p>
                    {data?.sala?.ordem}&#186;
                  </p>
                </Room.Card>
                <Room.Card>
                  <span>
                    <BsHeadset />
                  </span>
                  <p>
                    {data?.sala?.usuario}
                  </p>
                </Room.Card>
              </Room.Wrapper>
            }
          </Content>
          <Menu anchorEl={anchorEl} ref={refMenu}>
            {!isInRoom && allowAddInRoom &&
              <li onClick={() => handleAddInWaitingRoom()}>
                Adicionar a Sala de Espera
              </li>
            }
            <li onClick={() => handleOpenTransfer()}>
              Transferir Atendimento
            </li>
            <li onClick={() => handleOpenProfile()}>
              Ver Perfil
            </li>
          </Menu>
        </Wrapper>
      </Container>
      {loading && <Loading />
      }
      {
        profileOpen &&
        <ProfileClient
          client={data}
          isOpen={profileOpen}
          close={() => handleCloseProfile()}
          load={loadChats}
        />
      }
      <Modal
        title={titleTransfer()}
        isOpen={transferOpen}
        close={() => handleCloseTransfer()}
      >
        {transferOpen &&
          <TransferClient
            customer={data}
            close={() => handleCloseTransfer()}
          />
        }
      </Modal>
      <Modal
        title={'Anotação'}
        isOpen={noteOpen}
        close={() => handleCloseNote()}
      >
        {noteOpen &&
          <NoteClient idNote={data.id} />
        }
      </Modal>
      <Modal title={'Atendimento em aberto'}
        isOpen={customerServiceOpenData ? true : false}
        close={
          () => setCustomerServiceOpenData(null)
        }
      >
        <ViewerCustomerServiceOpen
          customerServiceOpen={customerServiceOpenData}
          onClose={
            () => setCustomerServiceOpenData(null)
          }
        />
      </Modal>
    </>
  );
}